import { createAsyncThunk } from "@reduxjs/toolkit";
import config from '../../config.js'

const API_URL = config.API_URL; // URL da API

// Thunk para buscar dashboards
export const fetchImages = createAsyncThunk("images/fetchImages", async () => {
    const response = await fetch(`${API_URL}/images/profiles`);
    if (!response.ok) throw new Error("Erro ao buscar imagens");
    return response.json();
});


